<div style="padding: 15px;">
  <div class="table-title">
  <h3>Home</h3>
</div>

<div class="dashboard-container">
  
  <nz-row [nzGutter]="[24, 24]" nzJustify="center">
    <nz-col 
      *ngFor="let item of dashboardItems;" 
      [nzXs]="24" 
      [nzSm]="12" 
      [nzMd]="8" 
      [nzLg]="8"
      [nzXl]="6"
    >
      <nz-card
        class="dashboard-card"
        [class]="'card-' + item.navigation"
        [nzHoverable]="true"
        [nzBordered]="true"
        (click)="navigateTo(item.navigation)"
      >
        <div class="card-content">
          <div class="card-icon" [style.color]="getBrandColor(item.navigation)">
            <fa-icon [icon]="getIcon(item.icon)" size="2x"></fa-icon>
          </div>
          <h3 class="card-title">{{ item.label }}</h3>
          <!--<p class="card-description"></p>-->
          <div class="card-action">
            <span nz-icon nzType="arrow-right" nzTheme="outline"></span>
          </div>
        </div>
      </nz-card>
    </nz-col>
  </nz-row>
</div>